export default {
  merchantsTypeCodeResults: [],
};
